// Skeleton-плейсхолдеры на время загрузки — мягче, чем текст «Загрузка…».

export function CatalogSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skel-card">
          <div className="skeleton skel-card__img" />
          <div className="skel-card__body">
            <div className="skeleton skel-line" style={{ width: "80%" }} />
            <div className="skeleton skel-line" style={{ width: "40%" }} />
            <div className="skeleton skel-line" style={{ width: "55%" }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ProductSkeleton() {
  return (
    <div className="container">
      <div className="skeleton" style={{ width: "100%", aspectRatio: "3/4", borderRadius: 16, margin: "12px 0" }} />
      <div className="skeleton skel-line" style={{ width: "70%", height: 22, marginBottom: 12 }} />
      <div className="skeleton skel-line" style={{ width: "30%", marginBottom: 8 }} />
      <div className="skeleton skel-line" style={{ width: "45%", height: 20, marginBottom: 16 }} />
      <div className="skeleton" style={{ width: "100%", height: 48, borderRadius: 12 }} />
    </div>
  );
}
